import React from 'react'
import * as reactstrap from 'reactstrap'
import { pt, buildPropTypes } from 'common-data/datahelpers'
import { FAIcon } from './FAIcon'
const { Button: RSButton } = reactstrap

export class Button extends React.Component {
  static propTypes = buildPropTypes([], {
    children: pt.node,
    disabled: pt.bool,
    loading: pt.bool
  })

  render () {
    const { children, loading, disabled, outline = false, ...rest } = this.props
    const { color } = rest
    return <RSButton outline={outline} disabled={loading || disabled} {...rest}>{loading ? <FAIcon name='spinner' dontApplyIconColor={outline === false} spin color={color} /> : null} {children}</RSButton>
  }
}
